import { FormLayout } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
import TextField from "./reusable/TextInput";

const Configuration = ({ handleEdit, isLoading, data }) => {
  const {
    handleSubmit,
    setError,
    register,
    formState: { errors },
  } = useForm<any>({
    defaultValues: async () => ({
      prefix: data?.prefix,
      postfix: data?.postfix,
      expression: data?.expression,
      reset_day: data?.reset_day,
      reset_month: data?.reset_month,
    }),
  });

  const output = data?.identifiers
    ? Object.entries(data?.identifiers).map(
        ([key, value]) => `${key}: ${value}`
      )
    : [];

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleEdit}
        setError={setError}
        buttonLabel={"Update"}
        isLoading={isLoading}
      >
        <div className={tw`grid grid-cols-3 gap-4 px-4`}>
          <TextField
            label="Prefix"
            register={register("prefix")}
            errors={errors?.prefix}
          />
          <TextField
            label="Expression"
            register={register("expression")}
            errors={errors?.expression}
          />
          <TextField
            label="Postfix"
            register={register("postfix")}
            errors={errors?.postfix}
          />
        </div>

        <div className={tw`mt-6 w-1/2 px-4`}>
          <h2 className={tw`text-lg font-semibold mb-2 text-gray-700`}>
            Reset Schedule
          </h2>
          <div className={tw`grid grid-cols-2 gap-4`}>
            <TextField
              label="Reset Month"
              register={register("reset_month", {
                min: { value: 0, message: "Minimum is 0" },
                max: { value: 12, message: "Maximum is 12" },
                valueAsNumber: true,
              })}
              min={0}
              max={12}
              errors={errors?.reset_month}
              type="number"
            />
            <TextField
              label="Reset Day"
              register={register("reset_day", {
                min: { value: 0, message: "Minimum is 0" },
                max: { value: 28, message: "Maximum is 28" },
                valueAsNumber: true,
              })}
              min={0}
              max={28}
              errors={errors?.reset_day}
              type="number"
            />
          </div>
        </div>
        <div className={tw`px-4 mt-6`}>
          <p className={tw`font-medium text-gray-800`}>
            Example:{" "}
            <span className={tw`text-primary`}>{data?.example_string}</span>
          </p>
        </div>
      </FormLayout>

      {output?.length > 0 && (
        <div className={tw`px-4 mt-6`}>
          <h3 className={tw`font-semibold text-center text-gray-700 mb-2`}>
            Identifiers
          </h3>
          <div
            className={tw`grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-2 border border-gray-300 p-4 rounded-md bg-gray-50`}
          >
            {output.map((item, index) => (
              <p
                key={index}
                className={tw`text-sm text-gray-800 bg-white border border-gray-200 p-2 rounded`}
              >
                {item}
              </p>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default Configuration;
